const MODAL_ID = 'rcb-exit-intent-modal';

export const getCurrentPage = () => {
  const modalElement = document.getElementById(MODAL_ID);

  if (!modalElement) return '';

  const modalContainer = modalElement.querySelector(
    '.rcb-exit-intent__container',
  );

  return modalContainer?.getAttribute('data-current-page') || '';
};


export function shouldShowModal() {
  return !sessionStorage.getItem(MODAL_ID);
}

export function setModalShown() {
  const modalElement = document.getElementById(MODAL_ID);
  const isBtnAction = modalElement?.dataset?.isBtnAction === 'true';

  if (isBtnAction) return;
  sessionStorage.setItem(MODAL_ID, 'true');
}
